import { Position, Toaster } from "@blueprintjs/core";
import styles from "./Toaster.module.css";

/** Singleton toaster instance. Create separate instances for different options. */
export const AppToaster = Toaster.create({
    className: styles.recipetoaster,
    position: Position.TOP,
});
